module.exports = __webpack_public_path__ + "img/shelves.3eb12f0d.svg";